import styled from "styled-components";

const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: var(--spacer-XS);
`;

export default ButtonsContainer;